<template>
    <div>

        <loading />
        <header-cna />

        <div class="container pb-5">
            <div class="criar-conta mt-4">
                <h2 class="text-center">
                    <strong>Trocar Senha</strong>
                </h2>

                <div class="dados-conta bg-white mt-3 rounded py-5 px-3 p-md-5 shadow">
                    <form class="form cf">
                        <div class="row" v-if="step == 1">
                            <div class="col-12">
                                <div>
                                    <strong>Olá, </strong>
                                </div>
                                <div class="mb-3">
                                    <label for="senha">Informe seu código de solicitação recebido no e-mail.</label>
                                    <input type="text" class="form-control" placeholder="Código de Solicitação" v-model="model.codigo" autocomplete="off" required />
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="step == 2 && result">
                            <div class="col-12 mb-3">
                                <div class="row">
                                    <div class="col-12 mb-3">
                                        <label for="senha">Informe sua nova Senha.</label>
                                        <input type="password" class="form-control" placeholder="Digite a nova senha" v-model="model.senha" autocomplete="off" required  />
                                    </div>
                                    <div class="col-12 mb-3">
                                        <label for="senhaConfirma">Confirme sua Senha.</label>
                                        <input type="password" class="form-control" placeholder="Digite novamente a senha" v-model="model.confirmacao" autocomplete="off" required />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="step == 3">
                            <div class="alert alert-success col-12 mb-3">
                                <i class="far fa-check-circle"></i>
                                <strong class="text-primary"> Sua senha foi alterada com sucesso. <br />Para acessar o sistema <a href="/">clique aqui</a> e informe seus dados!</strong>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-6 ">
                                <button type="button" class="btn btn-light border-primary rounded-pill previous-button px-4" @click="sendBack()">Voltar</button>
                            </div>
                            <div class="col-6 text-right" v-if="step != 3">
                                <button type="button" class="btn btn-primary bg-azul-escuro rounded-pill enviar-codigo px-4" @click="mudaPasso(step)">Continuar</button>
                            </div>
                        </div>
                    </form>
                </div>

            </div>
        </div>

    </div>

</template>



<script>
    import base from '@/common/base.js'
    import Global from '@/common/global'
    import { Api } from '@/common/api'

    import loading from '@/common/components/loading'
    import headerCna from '@/template/header'

    export default {
    name: 'trocar-senha',
    mixins: [base],
        components: {
            headerCna,
            loading,
        },
        data: () => ({

            step: 1,
            model: {},
            result: {},

        }),
        methods: {
            mudaPasso(step){
                switch (step) {
                    case 1 :
                        this.confirmaCodigoSolicitacao();
                        break;
                    case 2:
                        this.alteraSenha();
                    default:
                }
            },
            alteraSenha() {
                this.showLoading();
                new Api('pessoacnaacesso/AlteraSenhaUsuario').get(this.model).then(result => {
                    this.step = 3;
                    this.result = result.data;
                    this.hideLoading();
                }, err => {
                    this.hideLoading();
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors.join(),
                        modal: true,
                        html: true,
                    });
                })
            },
            confirmaCodigoSolicitacao() {
                this.showLoading();
                new Api('pessoacnaacesso/ConfirmaCodigoSolicitacao').get(this.model).then(result => {
                    this.step = 2;
                    this.result = result.data;
                    this.hideLoading();
                }, err => {
                    this.hideLoading();
                    this.$eventHub.$emit('show-notification', {
                        type: 'error',
                        title: 'Atenção',
                        text: err.data.errors.join(),
                        modal: true,
                        html: true,
                    });
                })
            },
            sendBack() {
                if (this.step == 1)
                    history.back();
                else
                    this.step--;
            }
        },

        mounted() {
            if (this.$route.query.codigo)
            {
                this.model.codigo = this.$route.query.codigo;
                this.confirmaCodigoSolicitacao();
            }
        }
    };
</script>
